<template>
  <Transition name="process-indicator">
    <div v-if="state.pending" class="process-indicator-overlay" role="status" aria-live="polite">
      <div class="process-indicator-card">
        <span class="process-indicator-spinner" aria-hidden="true"></span>
        <div>
          <strong>{{ state.message || 'Выполняем операцию…' }}</strong>
          <small>Пожалуйста, подождите</small>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { inject } from 'vue'

export default {
  setup() {
    return {
      state: inject('processIndicatorState')
    }
  }
}
</script>
